import { Transition } from 'react-transition-group';
import { useState, useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { requestCreateProfile } from "../../api/signcard";
import { BackBtn } from "../../components/header/btn/back-btn";
import { AddBtn } from "../../components/header/btn/add-btn";
import Header from "../../components/header/header";

const regex = new RegExp('^[0-9A-Za-z._-]{5,30}$');
const on = "primary"

function ProfileLinkGeneratePage() {
    const { state } = useLocation()
    const navigate = useNavigate();

    const [isFocus, setFocus] = useState(false);
    const [isValid, setValid] = useState(false);
    const [isOccupied, setOccupied] = useState(false);
    const inputContainer = useRef(null)
    const okBtn = useRef(null)

    const [cardUuid, setCardUuid] = useState(null)
    const [profileLink, setProfileLink] = useState("");

    const focus = () => setFocus(true);

    const blur = () => setFocus(false);

    const changeProfileLink = (e) => setProfileLink(e.target.value)

    const back = () => navigate(-1)

    useEffect(() => {
        if (state.cardUuid == null) {
            navigate("/not-found")
            return
        }

        setCardUuid(state.cardUuid)
    }, [navigate, state.cardUuid])

    useEffect(() => {
        setValid(regex.test(profileLink))
    }, [profileLink])

    // 물어보기
    useEffect(() => {
        if (isOccupied) {
            inputContainer.current.classList.remove('focus')
            inputContainer.current.classList.remove('valid')
            inputContainer.current.classList.add('not-valid')
        } else if (isValid) {
            inputContainer.current.classList.remove('focus')
            inputContainer.current.classList.remove('not-valid')
            inputContainer.current.classList.add('valid')
        } else if (isFocus) {
            inputContainer.current.classList.remove('not-valid')
            inputContainer.current.classList.remove('valid')
            inputContainer.current.classList.add('focus')
        } else {
            inputContainer.current.classList.remove('not-valid')
            inputContainer.current.classList.remove('valid')
            inputContainer.current.classList.remove('focus')
        }

        if (isValid) {
            okBtn.current.classList.add(on)
            okBtn.current.disabled = false
        } else {
            okBtn.current.classList.remove(on)
            okBtn.current.disabled = true
        }
    }, [isFocus, isValid, isOccupied])

    const createProfile = () => {
        const params = {
            cardUuid: cardUuid,
            profileLink: profileLink
        }

        requestCreateProfile(params)
            .then((_) => {
                navigate(`/profile/${profileLink}/edit`)
            })
            .catch((_) => {
                setOccupied(true)
            })
    }

    const renderErrMsg = () => {
        if (!isValid && profileLink !== "") {
            return <span className="plg-occupied-error">올바른 링크를 등록해주세요.</span>
        }
        else if (isOccupied) {
            return <span className="plg-occupied-error">이미 등록된 링크입니다.</span>
        }
    }

    const renderIcon = () => {
        if ((profileLink != "" && !isValid) || isOccupied) {
            return <img alt={""} className="valid-icon" src='/assets/icons/disallowed.png' />
        } else if (isValid) {
            return <img alt={""} className="valid-icon" src='/assets/icons/allowed.png' />
        }
    }


    return (
        <div className="Layer profile-link-generate">
            <Header>
                <BackBtn onClick={() => navigate(-1)} />
            </Header>
            <div className="Layer-inner">
                <div className="contents-container">
                    <div className="title-container">
                        <h3>프로필 링크 만들기</h3>
                    </div>
                    <div className="valid-input-wrapper" onFocus={focus} onBlur={blur}
                        tabIndex={0}>
                        <span className='fixed-text'>sign-card.com/</span>
                        <input ref={inputContainer} className='valid-input' id='link' name='profile-link' type='text' placeholder='name01'
                            onChange={changeProfileLink} autoComplete='off' />
                        <i className="valid-icon-container">
                            {renderIcon()}
                        </i>
                    </div>
                </div>
                <div className="message-btn-wrapper">
                    {renderErrMsg()}
                    <div className="primary-btn-container mt-40">
                        <button className="btn" type='submit' onClick={createProfile} ref={okBtn}>
                            다음
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ProfileLinkGeneratePage;
